import React from "react";

export const Container = ({ as: As = "div", className = "", children, ...rest }) => {
  return (
    <As
      className={`mx-auto w-full max-w-container px-6 sm:px-8 lg:px-12 ${className}`}
      {...rest}
    >
      {children}
    </As>
  );
};

export default Container;
